<template>
  <base-modal-ex v-if="isActive"
    :active.sync="isActive"
    :animation-in="animationIn"
    :animation-out="animationOut"
    :animation-duration="animationDuration"
    :can-cancel="false"
    :min-width="40"
    has-modal-card>
    <header class="modal-card-head">
      <div class="modal-card-title"
        :class="{ 'is-flex-items-center' : showIcon}">
        <span v-if="showIcon"
          class="icon is-medium"
          :class="`has-text-${iconType}`"
          style="margin-right: 0.5rem">
          <i class="mdi mdi-36px"
            :class="`${iconName}`" />
        </span>
        <!-- <slot name="text-title"></slot> -->
        <span>Submit Items to {{ value.audatex.taskType }} </span>
      </div>
    </header>
    <section class="modal-card-body">
      <div class="field">
        <notification-box class="mb-3"
          :type="'warning'">
          <p class="is-size-6"
            slot="text-content">
            <b>Important: Close quote in {{ value.audatex.taskType }} before submitting.</b><br>
            If the quote is open in {{ value.audatex.taskType }}, items submitted from FlexiQuote will not appear.
          </p>
        </notification-box>
      </div>
      <div v-if="isSubmitSublets && !isSubletItemsValid"
        class="field">
        <notification-box class="mb-3"
          :type="'error'">
          <p class="is-size-6"
            slot="text-content">
            <b>Validation: </b>
            Please select a Vendor for all Sublet items before submitting to AudaNet.
          </p>
        </notification-box>
      </div>
      <div class="has-text-centered mb-4">
        <label class="label"><span class="is-size-6">Select item types</span></label>
      </div>
      <div class="field is-grouped is-flex is-flex-wrap-wrap is-justify-content-center">
        <div class="field mr-4">
          <input class="is-checkradio"
            id="submitParts"
            type="checkbox"
            name="submitParts"
            v-model="isSubmitParts"
            :disabled="!hasParts">
          <label for="submitParts">Part Items</label>
        </div>
        <div class="field mr-4">
          <input class="is-checkradio"
            id="submitSublets"
            type="checkbox"
            name="submitSublets"
            v-model="isSubmitSublets"
            :disabled="!hasSublets">
          <label for="submitSublets">Sublet Items</label>
        </div>
        <div v-if="value.isAudaBridge"
          class="field mr-4">
          <input class="is-checkradio"
            id="submitLabours"
            type="checkbox"
            name="submitLabours"
            v-model="isSubmitLabours"
            :disabled="!hasLabours">
          <label for="submitLabours">Labour Items</label>
        </div>
        <div v-if="value.isAudaBridge"
          class="field mr-4">
          <input class="is-checkradio"
            id="submitPaints"
            type="checkbox"
            name="submitPaints"
            v-model="isSubmitPaints"
            :disabled="!hasPaints">
          <label for="submitPaints">Paint Items</label>
        </div>
      </div>
    </section>
    <footer class="modal-card-foot"
      :style="`justify-content: flex-${buttonLocation}`">
      <button class="button is-success tooltip"
        @click="submit()"
        data-tooltip="Submit"
        :disabled="!isSubmitLabours && !isSubmitPaints && !isSubmitParts && !isSubmitSublets || (!isSubletItemsValid)">
        <span class="icon is-small">
          <i class="mdi mdi-18px mdi-upload-multiple" />
        </span>
        <span>Submit</span>
      </button>
      <button class="button tooltip"
        @click="cancel()"
        data-tooltip="Cancel"
        :disabled="cancelDisabled">
        <span>Cancel</span>
      </button>
    </footer>
  </base-modal-ex>
</template>

<script>
import { BaseModalEx } from '@/components/BulmaModal'
import { ItemCategoryTypes } from '@/enums'
import NotificationBox from '@/components/Notification/NotificationBox.vue'

export default {
  name: 'AudanetSubmitItemsModal',
  components: {
    BaseModalEx,
    NotificationBox
  },
  props: {
    value: null,
    active: {
      type: Boolean,
      default: false
    },
    animationIn: {
      type: String,
      default: 'zoomIn'
    },
    animationOut: {
      type: String,
      default: 'zoomOut'
    },
    animationDuration: {
      type: [String, Number],
      default: 0.3
    },
    buttonLocation: {
      type: String,
      default: 'end' // valid values 'start' & 'end'
    },
    showIcon: {
      type: Boolean,
      default: true
    },
    iconType: {
      type: String,
      default: 'primary'
    },
    iconName: {
      type: String,
      default: 'mdi-upload-multiple'
    },
    copyDisabled: {
      type: Boolean,
      default: false
    },
    cancelDisabled: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      isActive: false,
      innerValue: null,
      isSubmitLabours: false,
      isSubmitPaints: false,
      isSubmitParts: false,
      isSubmitSublets: false
    }
  },
  validations: {},
  computed: {
    hasLabours() {
      const items = this.innerValue.labours.filter(i => i.itemType != ItemCategoryTypes.PAINT && !i.deleted)
      const miscItems = this.innerValue.miscs.filter(i => !i.deleted)
      const mechItems = this.innerValue.others.filter(i => i.itemType != ItemCategoryTypes.MECH && !i.deleted)
      return items.length > 0 || miscItems.length > 0 || mechItems.length > 0
    },
    hasPaints() {
      const items = this.innerValue.labours.filter(i => i.itemType === ItemCategoryTypes.PAINT && !i.deleted)
      return items.length > 0
    },
    hasParts() {
      const pItems = this.innerValue.parts.filter(i => !i.deleted)
      return pItems.length > 0
    },
    hasSublets() {
      const sItems = this.innerValue.sublets.filter(i => !i.deleted)
      return sItems.length > 0
    },
    isSubletItemsValid() {
      const subletItems = this.innerValue.sublets.filter((i) => (i.vendorId == null || i.vendorId == '')  && !i.deleted)
      if (subletItems.length > 0 && this.isSubmitSublets == true) {
        return false
      } else return true
    }
  },
  watch: {
    active(value) {
      this.isActive = value
    }
  },
  created() {
    this.innerValue = this.value
    this.isSubmitLabours = this.hasLabours && this.value.isAudaBridge
    this.isSubmitPaints = this.hasPaints && this.value.isAudaBridge
    this.isSubmitParts = this.hasParts
    this.isSubmitSublets = this.hasSublets
  },
  mounted() {
    this.isActive = this.active || false
  },
  methods: {
    submit() {
      this.$emit('submit', this.isSubmitLabours, this.isSubmitPaints, this.isSubmitParts, this.isSubmitSublets)
    },
    cancel() {
      this.$emit('cancel')
    }
  }
}
</script>

<style lang="scss" scoped>
.is-flex-items-center {
  display: flex;
  align-items: center;
}
</style>
